module.exports = __webpack_public_path__ + "img/logo.90f82f21.png";